{
  "title": "How to Advance Teams to the Next Round",
  "description": "Select teams from preliminary-round submissions and batch-advance them into the final round.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "When you're done, the selected teams appear in the final round, and their members receive an advancement notification email.",
  "roleNote": "Competition Admin",
  "prerequisites": [
    "The competition has both a preliminary and a final round set up",
    "Preliminary-round scoring is complete and you've decided who advances"
  ],
  "pathLabel": "Organizer Console → Final Round → Advancement List",
  "steps": [
    {
      "title": "1. Decide who advances",
      "description": "Based on preliminary scoring results or other considerations, decide which teams (via their preliminary submissions) should advance to the final round."
    },
    {
      "title": "2. Select preliminary submissions and submit",
      "description": "In the final round's advancement feature, check the corresponding preliminary submissions (selection is per submission — the system automatically maps each to its owning team), optionally add a note, and submit."
    },
    {
      "title": "3. Confirm the result",
      "description": "After submitting, each submission creates an advancement record; if a team has already been advanced into this round, it's automatically skipped rather than duplicated, so you can safely submit the same selection again in batches or after adding a few more teams."
    }
  ],
  "afterward": [
    "Advanced teams appear in the final round's roster and can start creating and submitting a new submission for that round",
    "Every member of the team except the teacher role receives an advancement notification email; the confirmation step states this beforehand, and the number sent and failed is recorded in the audit log",
    "Selecting an already-advanced team again causes no error and creates no duplicate record"
  ],
  "nextSteps": "Once teams have advanced, confirm the final round's schedule, submission form, and rubric are all configured so advanced teams can participate smoothly.",
  "faq": [
    {
      "q": "Can I select and submit the advancement list in multiple batches?",
      "a": "Yes. The system checks, per submission, whether that submission's team has already advanced into this round — an already-advanced team is skipped rather than duplicated, so you can submit a first batch, then come back and submit any teams you missed, without needing to select everyone at once."
    },
    {
      "q": "Is advancement done per submission or per team?",
      "a": "The interface has you check preliminary-round \"submissions\", but the advancement record that gets created is tied to that submission's \"team\". If a team has multiple preliminary submissions and any one of them is checked, that team counts as advanced."
    },
    {
      "q": "Does the advancement email go to everyone on the team?",
      "a": "It goes to every team member except anyone with the \"teacher\" role."
    }
  ]
}
